import React, { useEffect } from 'react';
import { Steps } from 'antd';

const { Step } = Steps;

interface StepData {
  title: string;
  description?: string;
}

interface StepComponentProps {
  current: number;
  steps: StepData[];
}
let filled:number[] = []
const StepComponent: React.FC<StepComponentProps> = ({ current, steps }) => {
  if(!filled.includes(current)){
    filled.push(current)
  }
  function isFilled(){
    if(current!==1){
      if(filled.length-1 == current){
      }
    }
  }
  isFilled()
  return (
    <div className="hp-container">
        <Steps labelPlacement='vertical' current={current}>
      {steps?.map((step, index) => (
        <Step key={index} title={step.title} description={""} />
      ))}
    </Steps>
    </div>
  );
};

export default StepComponent;
